/**
 * IDP API — Individual Development Plans (Sprint 2).
 */

import { apiFetch } from './core'

export const idp = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/idp${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/idp/${id}`),
    create: (data) => apiFetch('/idp', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    setStatus: (id, status) => apiFetch(`/idp/${id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status }),
    }),
    addGoal: (idpId, goal) => apiFetch(`/idp/${idpId}/goals`, {
        method: 'POST',
        body: JSON.stringify(goal),
    }),
    updateGoal: (goalId, patch) => apiFetch(`/idp/goals/${goalId}`, {
        method: 'PATCH',
        body: JSON.stringify(patch),
    }),
    deleteGoal: (goalId) => apiFetch(`/idp/goals/${goalId}`, { method: 'DELETE' }),
}
